module.exports = __webpack_public_path__ + "static/media/icon-barrel.da6d0f52.svg";